import { litePacketHooks } from './useDevicePacket';

export const useGeneratePacket = litePacketHooks.useGeneratePacket;
export const useParsePacket = litePacketHooks.useParsePacket;
